import React from "react";
import { FaPalette, FaCube, FaLayerGroup } from "react-icons/fa";

function DesigningUnique() {
  return (
    <>
      <div className="choose-us-style-two default-padding bg-gray blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading">
                <h4 className="sub-title">Design Startup</h4>
                <h2 className="title split-text-right split-text-in-right">
                  NFT Development Service by Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row align-center">
            <div className="col-lg-6">
              <div className="choose-us-two-thumb">
                <img
                  src="https://validthemes.net/site-template/robok/assets/img/thumb/5.jpg"
                  alt="Image Not Found"
                />
              </div>
            </div>

            <div className="col-lg-6 pl-20 pl-md-15 pl-xs-10">
              <div className="choose-us-two-info">
                <p>
                  At Xeer Technology, we specialize in offering comprehensive
                  NFT development services, tailored to meet the unique needs of
                  creators, businesses, and developers looking to enter the
                  fast-growing world of non-fungible tokens. From
                  conceptualization to deployment, we help you build and launch
                  NFTs that stand out in the marketplace.
                </p>

                <ul className="list-style-four">
                  <li>
                    <div className="icon">
                      <FaPalette size={35} />
                    </div>
                    <div className="info">
                      <h4>Designing Unique Digital Arts</h4>
                    </div>
                  </li>

                  <li>
                    <div className="icon">
                      <FaCube size={35} />
                    </div>
                    <div className="info">
                      <h4>Minting Tokens on Blockchain</h4>
                    </div>
                  </li>

                  <li>
                    <div className="icon">
                      <FaLayerGroup size={35} />
                    </div>
                    <div className="info">
                      <h4>Managing NFT Collections</h4>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DesigningUnique;
